import Vue from 'vue';
import Vuex from 'vuex';

// root
import {
  state,
  mutations,
  actions,
  getters
} from './public.js';


// modules
import grid from './modules/grid.js';
import form from './modules/form.js';
import message from './modules/message.js';
import criteria from './modules/criteria.js'
import filters from './modules/filters.js'

Vue.use(Vuex);

export default new Vuex.Store({
  // root
  state,
  mutations,
  getters,
  actions,

  modules: {
    grid,
    form,
    message,
    criteria,
    filters
  },

  strict: true
});